import React from "react";

const AuthFormHeader = ({ title, subtitle }) => (
  <div className="mb-6 text-center sm:mb-8">
    <div className="relative mx-auto mb-5 inline-flex h-11 w-11 items-center justify-center">
      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-amber-400/20 to-amber-600/10 blur-lg" />
      <div className="relative flex h-full w-full items-center justify-center rounded-full border border-amber-400/25 bg-slate-900/60 backdrop-blur-sm">
        <div className="h-3 w-3 rounded-full bg-gradient-to-br from-amber-300 to-amber-600 shadow-md shadow-amber-400/30" />
      </div>
    </div>
    <h2 className="text-2xl font-light tracking-tight text-white sm:text-[1.65rem]">
      {title}
    </h2>
    {subtitle && (
      <p className="mx-auto mt-2 max-w-xs text-sm font-light leading-relaxed text-slate-400">
        {subtitle}
      </p>
    )}
    <div className="mx-auto mt-5 h-px w-16 bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />
  </div>
);

export default AuthFormHeader;
